(() => {
  if (window.FFHomeCompactRails) {
    window.FFHomeCompactRails.initialize();
    return;
  }
  const mobile = matchMedia('(max-width: 620px)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new Map();
  function attach(root) {
    if (instances.has(root)) return;
    const rail = root.querySelector('[data-ff-rail]');
    if (!rail) return;
    const controller = new AbortController();
    const options = {signal: controller.signal};
    let frame = 0;
    const items = () => [...rail.querySelectorAll('[data-doc-card],[data-ff-rail-item]')].filter(item => !item.hidden);
    const current = () => {
      const visible = items();
      const left = rail.getBoundingClientRect().left;
      return visible.reduce((best, item, index) => Math.abs(item.getBoundingClientRect().left - left) < Math.abs(visible[best].getBoundingClientRect().left - left) ? index : best, 0);
    };
    function update() {
      const count = items().length;
      const index = current();
      root.querySelectorAll('[data-ff-rail-status]').forEach(node => { node.textContent = count ? `${index + 1} / ${count}` : '0 / 0'; });
      root.querySelectorAll('[data-ff-rail-prev]').forEach(button => { button.disabled = index === 0; });
      root.querySelectorAll('[data-ff-rail-next]').forEach(button => { button.disabled = index >= count - 1; });
      root.querySelectorAll('[data-ff-rail-target]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.ffRailTarget) === index)));
    }
    function schedule() {
      if (frame) return;
      frame = requestAnimationFrame(() => { frame = 0; update(); });
    }
    function go(index) {
      if (!mobile.matches) return;
      const visible = items();
      const item = visible[Math.max(0, Math.min(index, visible.length - 1))];
      if (!item) return;
      const left = rail.scrollLeft + item.getBoundingClientRect().left - rail.getBoundingClientRect().left;
      rail.scrollTo({left, behavior: reduced.matches ? 'instant' : 'smooth'});
    }
    function resize() {
      root.querySelectorAll('[data-ff-rail-controls]').forEach(node => { node.hidden = false; });
      root.querySelectorAll('[data-doc-details]').forEach(node => { node.open = !mobile.matches; });
      if (!mobile.matches) rail.scrollLeft = 0;
      rail.tabIndex = mobile.matches ? 0 : -1;
      schedule();
    }
    root.addEventListener('click', event => {
      const target = event.target.closest('button');
      if (!target) return;
      if (target.hasAttribute('data-ff-rail-prev')) go(current() - 1);
      if (target.hasAttribute('data-ff-rail-next')) go(current() + 1);
      if (target.hasAttribute('data-ff-rail-target')) go(Number(target.dataset.ffRailTarget));
      if (target.hasAttribute('data-doc-filter')) {
        requestAnimationFrame(() => { rail.scrollTo({left: 0, behavior: 'instant'}); update(); });
      }
    }, options);
    rail.addEventListener('keydown', event => {
      if (event.target !== rail || !mobile.matches) return;
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home') go(0);
      else if (event.key === 'End') go(items().length - 1);
      else go(current() + (event.key === 'ArrowRight' ? 1 : -1));
    }, options);
    rail.addEventListener('scroll', schedule, {...options, passive: true});
    mobile.addEventListener('change', resize, options);
    const observer = new ResizeObserver(schedule);
    observer.observe(rail);
    instances.set(root, () => { controller.abort(); observer.disconnect(); cancelAnimationFrame(frame); });
    resize();
  }
  function initialize(scope = document) {
    const roots = [...scope.querySelectorAll('[data-ff-scroll-section]')];
    if (scope.matches?.('[data-ff-scroll-section]')) roots.unshift(scope);
    roots.forEach(attach);
  }
  window.FFHomeCompactRails = {initialize};
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((cleanup, root) => {
      if (!event.target.contains(root)) return;
      cleanup();
      instances.delete(root);
    });
  });
  initialize();
})();
